module.exports = __webpack_public_path__ + "img/img4.4bc7c41c.jpg";